import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Adresse } from '@martinus/address/entities/Adresse.js';
import { BankDaten } from './BankDaten.js';
import { StammDaten } from './StammDaten.js';

@Entity()
export class ProfilDaten extends AdornisEntity {
  static override _class = 'ProfilDaten';

  constructor(doc: PartialEntityData<ProfilDaten>) {
    super(doc);
  }

  @Field(() => StammDaten, { default: v => v ?? new StammDaten({}) })
  stammdaten: Maybe<StammDaten>;

  @Field(() => Adresse)
  adresse: Maybe<Adresse>;

  @Field(() => BankDaten)
  bankInfos: Maybe<BankDaten>;
}
